import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {ScheduleOccurrence} from '../../domain/schedule-occurrence';
import type {ScheduleRepository} from '../ports/schedule.repository';

export class SkipScheduleOccurrence implements UseCase<[ScheduleOccurrence], void> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(occurrence: ScheduleOccurrence): Promise<Result<void, ScheduleError>> {
    return this.repository.skipOccurrence(occurrence);
  }
}
